import React from 'react'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import { ViewProps } from 'react-native'
import { AccessType, useCompany } from 'zens-store'
import { usePermissions } from '@dms/hook'

import { InfoTable } from '../info'

import OccupancyColor from './occupancycolor'

interface Props extends ViewProps {
  companyId: number
}

const CompanyOccupancyColors = ({ companyId, ...props }: Props) => {
  const { t } = useTranslation()
  const company = useCompany({ companyId })
  const { hasPermission } = usePermissions(companyId)
  const colors = Object.entries(company.data?.configuredOccupancyColors || {})

  if (!hasPermission(AccessType.Read, 'settings')) return null

  return (
    <InfoTable
      {...props}
      companyId={companyId}
      title={t('Occupancy colors')}
      buttonTitle={t('Edit')}
      buttonHref={hasPermission(AccessType.Update, 'settings') ? `/companies/${companyId}/occupancy-colors` : undefined}
      config={{
        fields: colors.length
          ? colors.map(([label, color]) => ({
              label: label === 'free' ? t('Free') : label === 'occupied' ? t('Occupied') : label.replace(/_/g, ' '),
              value: <OccupancyColor value={color} />,
            }))
          : [{ label: t('Status'), value: t('Not configured') }],
      }}
    />
  )
}

const Skeleton = (props: ViewProps) => {
  const { t } = useTranslation()
  return <InfoTable.Skeleton {...props} title={t('Occupancy colors')} />
}

CompanyOccupancyColors.Skeleton = Skeleton

export default observer(CompanyOccupancyColors)
